import React, { useRef, useState } from "react";
import "./ViewCandidate.scss";
import {
  CalculateOutlined,
  CreditCard,
  FileOpenOutlined,
  PublishOutlined,
  StarOutlineSharp,
  ThumbDownOffAltOutlined,
} from "@mui/icons-material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Empty, Modal, Radio, Spin, Tooltip } from "antd";
import { Table } from "antd";
import ViewCandidateService from "./ViewCandidateService";
import {
  JOB_STATUS_CONFIG,
  JobApplicationStatusEnum,
  JobApplicationStatusLabel,
  JobApplicationStatusText,
} from "Constants/Enums/JobApplicantStatusEnum";
import { getEnumKey } from "Utils/EnumUtils";
import { JobPostingStatusEnum } from "Constants/Enums/JobPostingStatusEnum";
import { EmploymentTypeEnumLabel } from "Constants/Enums/EmploymentTypeEnum";
import { useNavigate } from "react-router-dom";

// Color + label for each status pill shown at the top-right of a candidate card.
const STATUS_PILL = {
  [JobApplicationStatusEnum.Applied]: { color: "#1677ff", bg: "#eef3ff", label: "Applied" },
  [JobApplicationStatusEnum.ShortList]: { color: "#0891b2", bg: "#e0f7fa", label: "Shortlisted" },
  [JobApplicationStatusEnum.TermsAccepted]: { color: "#0d9488", bg: "#ccfbf1", label: "Terms Accepted" },
  [JobApplicationStatusEnum.InterviewInProgress]: { color: "#c26b2c", bg: "#fff0db", label: "Interview In Progress" },
  [JobApplicationStatusEnum.InterviewCompleted]: { color: "#7c3aed", bg: "#f5f3ff", label: "Interview Completed" },
  [JobApplicationStatusEnum.FeedbackAdded]: { color: "#2b7e3a", bg: "#dff5e3", label: "Feedback Added" },
  [JobApplicationStatusEnum.DocumentSend]: { color: "#1677ff", bg: "#eef3ff", label: "Documents Sent" },
  [JobApplicationStatusEnum.DocumentRecieved]: { color: "#2b7e3a", bg: "#dff5e3", label: "Documents Received" },
  [JobApplicationStatusEnum.OnboardingDone]: { color: "#2b7e3a", bg: "#dff5e3", label: "Onboarding Done" },
  [JobApplicationStatusEnum.Hired]: { color: "#0f5a2a", bg: "#dff5e3", label: "Hired" },
  [JobApplicationStatusEnum.Reject]: { color: "#b13e3e", bg: "#fff0ee", label: "Rejected" },
};

// eslint-disable-next-line react/prop-types
function InfoItem({ label, value }) {
  if (value == null || value === "") return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <span style={{ fontSize: "0.7rem", color: "#617e63", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px" }}>
        {label}
      </span>
      <span style={{ fontSize: "0.88rem", color: "#1e2f1e", fontWeight: 500, marginTop: "2px", wordBreak: "break-word" }}>
        {value}
      </span>
    </div>
  );
}

// Open a URL in a new tab (used for Preview).
function openInNewTab(url) {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
}

// Trigger a download in the browser without leaving the page.
function downloadFile(url, fileName) {
  if (!url) return;
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "document";
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// eslint-disable-next-line react/prop-types
function DocActions({ icon, label, onPreview, onDownload }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: "#f0f4f0",
        borderRadius: "40px",
        padding: "4px 4px 4px 12px",
        border: "1px solid #d4e1d4",
      }}
    >
      <span style={{ fontSize: "0.85rem", fontWeight: 500, color: "#0f5a2a", marginRight: "4px" }}>
        {icon} {label}
      </span>
      <button
        type="button"
        onClick={onPreview}
        style={{
          background: "#fff",
          border: "1px solid #2b7e3a",
          color: "#2b7e3a",
          padding: "4px 12px",
          borderRadius: "40px",
          fontSize: "0.72rem",
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        {"👁 Preview"}
      </button>
      <button
        type="button"
        onClick={onDownload}
        style={{
          background: "#0f5a2a",
          color: "white",
          border: "1px solid #0f5a2a",
          padding: "4px 12px",
          borderRadius: "40px",
          fontSize: "0.72rem",
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        {"⬇ Download"}
      </button>
    </div>
  );
}

function CandidateList() {
  const apiUrl = process.env.REACT_APP_API_URL;
  // Files (resume/cover letter) are served from the bare host, not under /api.
  // process.env.REACT_APP_Base_URL is the file-server root.
  const fileBaseUrl = process.env.REACT_APP_Base_URL || apiUrl;
  const navigate = useNavigate();
  const {
    feedbacks,

    renderButton,
    jobDetails,
    employeeDetails,
    statusCounts,

    handleShortListClick,
    isFiltering,

    handleDelete,
    handlePdfPreview,
    handlecoverLetterPdfPreview,
    handleOnboarding,

    open,
    jobApplicantId,
    email,
    firstDateTime,
    secondDateTime,
    thirdDateTime,
    setFirstDateTime,
    setSecondDateTime,
    setThirdDateTime,
    handleOk,
    handleCancel,

    feedbackData,
    setFeedbackData,
    handleSubmitFeedback,
    openfeedback,
    setOpenfeedback,

    openContract,
    employeeContract,
    contractPdf,
    handleContractCancel,
    empId,

    columns,
    selectedPdf,
    selectedCoverLetter,
    loading,
    loadingjobApplicantId,
    formatDateTime,
    jobPostingId,
    handleFileDownload,
    isOnboardingDisabled
  } = ViewCandidateService();
  
  const containerRef = useRef(null);
  const [activeCard, setActiveCard] = useState(0);
  const [activeButton, setActiveButton] = useState("overall");

  const handleCardClick = (index) => {
    setActiveCard(index);
  };


  const scrollToContainer = () => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <div className="row">
        <ToastContainer />
        <div className="col-md-4">
          <div className="card cardSet" style={{ height: "575px" }}>
            <div className="card-body" style={{ overflowY: "auto" }}>
              {" "}
              <div className="d-flex align-items-center">
                <span className="ml-2" style={{ fontSize: "medium", cursor: "pointer" }}>
                  CandidateList
                </span>
              </div>
              <hr style={{ marginTop: "5px" }}></hr>
              <div>
                {jobDetails && (
                  <>
                    <h3 style={{ color: "green", fontFamily: "system-ui" }}>
                      {jobDetails.jobTitle}
                    </h3>
                    <p className="textspan">
                      <CalculateOutlined /> &nbsp;&nbsp;
                      <span>{jobDetails.jobTitle}</span>
                    </p>
                    <p className="textp">
                      <CreditCard />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span>{jobDetails.compensation} USD/Month</span>
                    </p>
                    <p className="textp">
                      <PublishOutlined />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span>{formatDateTime(jobDetails.createdOn)}</span>
                    </p>
                    <p className="textp">
                      <span>
                        <StarOutlineSharp />
                        &nbsp;&nbsp;&nbsp;&nbsp;Status:{" "}
                        <span style={{ color: "green" }}>
                          {getEnumKey(JobPostingStatusEnum, jobDetails.status)}
                        </span>
                      </span>
                    </p>
                    {/* Full job-posting details (Jun-20 punch-list). InfoItem
                        hides any field the posting does not have. */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        marginTop: "6px",
                      }}
                    >
                      <InfoItem label="Department" value={jobDetails.departmentName} />
                      <InfoItem label="Job Type" value={jobDetails.jobType} />
                      <InfoItem label="Location Type" value={jobDetails.jobLocationType} />
                      <InfoItem
                        label="Employment Type"
                        value={EmploymentTypeEnumLabel[jobDetails.employmentType]}
                      />
                      <InfoItem label="Experience" value={jobDetails.maximumExperience} />
                      <InfoItem label="Internal Code" value={jobDetails.jobInternalCode} />
                    </div>
                    {/* <p className="textp">
                      <span>
                        <CalendarMonthOutlined />
                        &nbsp;&nbsp;&nbsp;&nbsp;Application till:{" "}
                        <span style={{ color: "red" }}>05/02/2024</span>
                      </span>
                    </p> */}
                  </>
                )}
              </div>
              <div className="col-md-10">
                <h5>Candidate List</h5>

                {Object.entries(JOB_STATUS_CONFIG).map(([status, config]) => (
                  <React.Fragment key={status}>
                    <button
                      type="button"
                      className={`btn-custom ${activeButton === config.key ? "active" : ""}`}
                      disabled={isFiltering}
                      onClick={() => {
                        setActiveButton(config.key);
                        handleShortListClick(jobPostingId, Number(status));
                        scrollToContainer();
                      }}
                    >
                      {config.label}
                    </button>

                    <div className="number-box">
                      <span className="badge number-box-span">{statusCounts[status] || 0}</span>
                    </div>

                    <br />
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card cardSet-i" style={{ height: "575px" }}>
            <div className="d-flex align-items-center">
              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="ml-2" style={{ fontSize: "medium", marginTop: "15px" }}></span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-end mb-3 right-align-container">
              <span className="spec-hr">VelorHR</span>&nbsp;&nbsp;
              <h6> Posting Process</h6>
            </div>

            <div className="scrollable-container" ref={containerRef}>
              <div className="container">
                {loading ? (
                  <div
                    className="card"
                    style={{
                      height: "450px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <div>
                    {!employeeDetails ? (
                      <div
                        className="card"
                        style={{
                          height: "450px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Empty description="No Candidate available" />
                      </div>
                    ) : (
                      <div>
                        {employeeDetails
                          .filter((info) => !info.SoftDeleted)
                          .map((info, index) => {
                            const isActive = activeCard === index;
                            const statusInfo =
                              STATUS_PILL[info.status] || {
                                color: "#8c8c8c",
                                bg: "#f0f0f0",
                                label:
                                  JobApplicationStatusLabel[info.status] ||
                                  "Unknown",
                              };
                            const fbItem =
                              feedbacks && feedbacks.length > 0
                                ? feedbacks.find((f) => f.email === info.email)
                                : null;
                            return (
                              <div
                                key={info.jobApplicantId}
                                onClick={() => handleCardClick(index)}
                                style={{
                                  background: "white",
                                  borderRadius: "24px",
                                  padding: "20px 22px",
                                  boxShadow: isActive
                                    ? "0 6px 18px rgba(15,90,42,0.15)"
                                    : "0 4px 12px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.03)",
                                  border: `1px solid ${
                                    isActive ? "#2b7e3a" : "#e6ede6"
                                  }`,
                                  borderLeft: `5px solid ${statusInfo.color}`,
                                  marginBottom: "1rem",
                                  cursor: "pointer",
                                  transition: "all 0.15s ease",
                                  fontFamily:
                                    "'Inter', system-ui, -apple-system, sans-serif",
                                }}
                              >
                                {/* Header: name + status pill */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                    gap: "10px",
                                    marginBottom: "14px",
                                  }}
                                >
                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "1.15rem",
                                          fontWeight: 600,
                                          color: "#0f5a2a",
                                        }}
                                      >
                                        {info.firstName} {info.lastName}
                                      </span>
                                      {info.source === 1 && (
                                        <span
                                          style={{
                                            background: "#dff5e3",
                                            color: "#0f5a2a",
                                            padding: "2px 10px",
                                            borderRadius: "20px",
                                            fontSize: "0.7rem",
                                            fontWeight: 600,
                                            letterSpacing: "0.3px",
                                          }}
                                        >
                                          INTERNAL
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "0.85rem",
                                        color: "#5b7060",
                                        marginTop: "3px",
                                      }}
                                    >
                                      ✉️ {info.email}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {/* AI fit score — per Mudassir May-21: when
                                        the AI service is down, backend returns
                                        null. Show "AI down" with tooltip so
                                        HR knows it isn't a missing-data issue. */}
                                    <span
                                      title={
                                        info.fitScore != null
                                          ? "AI fit score"
                                          : "AI temporarily unavailable — score will populate once the AI service is restored"
                                      }
                                      style={{
                                        background: info.fitScore != null ? "#f0f9f1" : "#fff7ed",
                                        color: info.fitScore != null ? "#0f5a2a" : "#92400e",
                                        padding: "6px 14px",
                                        borderRadius: "40px",
                                        fontSize: "0.78rem",
                                        fontWeight: 700,
                                        border: `1px solid ${info.fitScore != null ? "#c7e3cd" : "#fcd34d"}`,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {info.fitScore != null
                                        ? `🎯 ${Math.round(info.fitScore)}/100`
                                        : "🤖 AI unavailable"}
                                    </span>
                                    <span
                                      style={{
                                        background: statusInfo.bg,
                                        color: statusInfo.color,
                                        padding: "6px 16px",
                                        borderRadius: "40px",
                                        fontSize: "0.72rem",
                                        fontWeight: 600,
                                        letterSpacing: "0.3px",
                                        textTransform: "uppercase",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {statusInfo.label}
                                    </span>
                                  </div>
                                </div>

                                {/* Personal info grid */}
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                                    gap: "10px 24px",
                                    marginBottom: "14px",
                                  }}
                                >
                                  <InfoItem label="Application ID" value={info.publicId} />
                                  <InfoItem label="Phone" value={info.mobileno} />
                                  <InfoItem label="City" value={info.city} />
                                  <InfoItem label="Address" value={info.streetAddress} />
                                  <InfoItem label="State" value={info.state} />
                                  <InfoItem label="ZIP" value={info.postalCode} />
                                  <InfoItem label="Applied On" value={info.appliedOn} />
                                  <InfoItem
                                    label="Interview Time"
                                    value={info.dateAvailable}
                                  />
                                  {fbItem && fbItem.marksAverage != null && (
                                    <InfoItem
                                      label="Feedback Avg"
                                      value={fbItem.marksAverage}
                                    />
                                  )}
                                </div>

                                {/* Stage description */}
                                <div
                                  style={{
                                    background: "#f6faf6",
                                    padding: "10px 14px",
                                    borderRadius: "14px",
                                    fontSize: "0.85rem",
                                    color: "#3e5a3e",
                                    marginBottom: "14px",
                                    borderLeft: "3px solid #2b7e3a",
                                    lineHeight: 1.5,
                                  }}
                                >
                                  {JobApplicationStatusText[info.status]}
                                </div>

                                {/* Documents */}
                                {(info.resume || info.coverLetter) && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "10px",
                                      marginBottom: "14px",
                                    }}
                                  >
                                    {info.resume && (
                                      <DocActions
                                        icon="📄"
                                        label="Resume"
                                        onPreview={(e) => {
                                          e.stopPropagation();
                                          openInNewTab(`${fileBaseUrl}/${info.resume}`);
                                        }}
                                        onDownload={(e) => {
                                          e.stopPropagation();
                                          downloadFile(
                                            `${fileBaseUrl}/${info.resume}`,
                                            `${info.firstName}_${info.lastName}_Resume`
                                          );
                                        }}
                                      />
                                    )}
                                    {info.coverLetter && (
                                      <DocActions
                                        icon="✉️"
                                        label="Cover Letter"
                                        onPreview={(e) => {
                                          e.stopPropagation();
                                          openInNewTab(`${fileBaseUrl}/${info.coverLetter}`);
                                        }}
                                        onDownload={(e) => {
                                          e.stopPropagation();
                                          downloadFile(
                                            `${fileBaseUrl}/${info.coverLetter}`,
                                            `${info.firstName}_${info.lastName}_CoverLetter`
                                          );
                                        }}
                                      />
                                    )}
                                  </div>
                                )}

                                {/* Actions */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(
                                        `/applicant-detail/${info.jobApplicantId}`
                                      );
                                    }}
                                    style={{
                                      padding: "8px 18px",
                                      background: "#0f5a2a",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "40px",
                                      fontSize: "0.85rem",
                                      fontWeight: 600,
                                      cursor: "pointer",
                                      fontFamily: "inherit",
                                      boxShadow: "0 2px 6px rgba(15,90,42,0.18)",
                                    }}
                                  >
                                    View Details →
                                  </button>
                                  {renderButton(info)}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <embed src={selectedPdf} type="application/pdf" width="100%" height="450px" />
<embed src={selectedCoverLetter} type="application/pdf" width="100%" height="450px" />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="coverLetter"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="coverLetterLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <embed
                    src={selectedCoverLetter}
                    type="application/pdf"
                    width="100%"
                    height="450px"
                  />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* -----------Interview Date Option Modal------------ */}
          <Modal
            open={open}
            title="Interview Schedule"
            onOk={() =>
              handleOk(jobApplicantId, email, firstDateTime, secondDateTime, thirdDateTime)
            }
            onCancel={handleCancel}
            footer={(_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn className="btn-back" />
                <OkBtn className="btn-primary" />
              </>
            )}
          >
            <hr></hr>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label
                  htmlFor="firstDateTime"
                  className="form-label"
                  style={{ fontSize: "medium" }}
                >
                  First Date time *
                </label>
                <input
                  id="firstDateTime"
                  type="datetime-local"
                  value={firstDateTime}
                  onChange={(e) => setFirstDateTime(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label
                  htmlFor="secondDateTime"
                  className="form-label"
                  style={{ fontSize: "medium" }}
                >
                  Second Date time *
                </label>
                <input
                  id="secondDateTime"
                  type="datetime-local"
                  value={secondDateTime}
                  onChange={(e) => setSecondDateTime(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label
                  htmlFor="thirdDateTime"
                  className="form-label"
                  style={{ fontSize: "medium" }}
                >
                  Third Date time *
                </label>
                <input
                  id="thirdDateTime"
                  type="datetime-local"
                  value={thirdDateTime}
                  onChange={(e) => setThirdDateTime(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
          </Modal>
          {/* {--------------Feedback Modal---------------} */}
          <Modal
            open={openfeedback}
            title="Interview Feedback Form"
            onCancel={() => setOpenfeedback(false)}
            footer={null}
            width={800}
          >
            <hr />

            {/* Candidate Info */}
            

            {/* Evaluation Scores */}
            <h5>Evaluation Scores (1 - 10)</h5>

            <div style={{ display: "flex", gap: "15px", marginBottom: "10px" }}>
              <div style={{ flex: 1 }}>
                <label><b>Technical proficiency in required skills</b></label>
                <input type="number" min="1" max="10" value={feedbackData.technicalSkills}
                  onChange={(e) => setFeedbackData({ ...feedbackData, technicalSkills: Number(e.target.value) })}
                  style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
              </div>
              <div style={{ flex: 1 }}>
                <label><b>Communication effectiveness during discussion</b></label>
                <input type="number" min="1" max="10" value={feedbackData.communication}
                  onChange={(e) => setFeedbackData({ ...feedbackData, communication: Number(e.target.value) })}
                  style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
              </div>
            </div>

            <div style={{ display: "flex", gap: "15px", marginBottom: "10px" }}>
              <div style={{ flex: 1 }}>
                <label><b>Problem-solving and analytical thinking</b></label>
                <input type="number" min="1" max="10" value={feedbackData.problemSolving}
                  onChange={(e) => setFeedbackData({ ...feedbackData, problemSolving: Number(e.target.value) })}
                  style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
              </div>
              <div style={{ flex: 1 }}>
                <label><b>Relevant experience & background alignment</b></label>
                <input type="number" min="1" max="10" value={feedbackData.experienceFit}
                  onChange={(e) => setFeedbackData({ ...feedbackData, experienceFit: Number(e.target.value) })}
                  style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
              </div>
            </div>

            <div style={{ marginBottom: "10px" }}>
              <label><b>Team collaboration & cultural fit</b></label>
              <input type="number" min="1" max="10" value={feedbackData.teamFit}
                onChange={(e) => setFeedbackData({ ...feedbackData, teamFit: Number(e.target.value) })}
                style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label><b>Overall interview performance rating</b></label>
              <input type="number" min="1" max="10" value={feedbackData.overallRating}
                onChange={(e) => setFeedbackData({ ...feedbackData, overallRating: Number(e.target.value) })}
                style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
            </div>

            {/* Interview Insights */}
            <h5>Interview Insights</h5>

            <div style={{ marginBottom: "10px" }}>
              <label><b>Candidate strengths observed during interview</b></label>
              <textarea rows="3" value={feedbackData.strengths}
                onChange={(e) => setFeedbackData({ ...feedbackData, strengths: e.target.value })}
                style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
            </div>

            <div style={{ marginBottom: "10px" }}>
              <label><b>Concerns or areas for improvement</b></label>
              <textarea rows="3" value={feedbackData.concerns}
                onChange={(e) => setFeedbackData({ ...feedbackData, concerns: e.target.value })}
                style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label><b>Key behavioral and technical observations</b></label>
              <textarea rows="3" value={feedbackData.keyObservations}
                onChange={(e) => setFeedbackData({ ...feedbackData, keyObservations: e.target.value })}
                style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "6px", marginTop: "5px" }} />
            </div>

            <button onClick={handleSubmitFeedback}
              style={{ width: "100%", padding: "12px", background: "#2d6cdf", color: "white",
                border: "none", borderRadius: "6px", fontSize: "16px", cursor: "pointer" }}>
              Submit Feedback
            </button>
          </Modal>

          {/* -----------Contract Modal------------ */}

          <Modal
            open={openContract}
            title="Employee Contract Documents"
            // onOk={handleJobOfferClick}
            onCancel={handleContractCancel}
            footer={(_, { CancelBtn }) => {
              if (employeeContract?.jobApplicant.status === JobApplicationStatusEnum.Hired) {
                return (
                  <>
                    <CancelBtn />
                    <Button  disabled className="btn-primary">
                      Hired
                    </Button>
                  </>
                );
              }

              if (
                employeeContract?.jobApplicant.status === JobApplicationStatusEnum.OnboardingDone
              ) {
                return (
                  <>
                    <CancelBtn />
                    <Button
                      className="btn-primary"
                      onClick={() =>
                        handleOnboarding(empId, JobApplicationStatusEnum.OnboardingDone)
                      }
                    >
                      Personal Info
                    </Button>
                  </>
                );
              }

              return (
                <>
                  <CancelBtn />
                  <Tooltip title="Download all documents  first">
                  <Button 
                  className="btn-primary"
                  disabled={isOnboardingDisabled(empId)}
                   onClick={() => handleOnboarding(empId)}>
                    Onboarding
                  </Button>
                  </Tooltip>
                </>
              );
            }}
          >
            <hr></hr>
            <div className="row">
              <div className="row mb-3">
                {employeeContract ? (
                  <Table
                    dataSource={[
                      employeeContract.ndafile
                        ? { key: "ndafile", name: "NDA File", file: employeeContract.ndafile }
                        : null,
                      employeeContract.ncafile
                        ? { key: "ncafile", name: "NCA File", file: employeeContract.ncafile }
                        : null,
                      employeeContract.employeeAgreement
                        ? {
                            key: "employeeAgreement",
                            name: "Employee Agreement",
                            file: employeeContract.employeeAgreement,
                          }
                        : null,
                      employeeContract.i_nine
                        ? { key: "i_nine", name: "I-9 File", file: employeeContract.i_nine }
                        : null,
                      employeeContract.w_four
                        ? { key: "w_four", name: "W-4 File", file: employeeContract.w_four }
                        : null,
                      employeeContract.offerLetter
                        ? {
                            key: "offerLetter",
                            name: "Offer Letter",
                            file: employeeContract.offerLetter,
                          }
                        : null,
                      employeeContract.hrPolicy
                        ? {
                            key: "hrPolicy",
                            name: "HR Policy",
                            file: employeeContract.hrPolicy,
                          }
                        : null,
                    ].filter((item) => item !== null)} // Filter out null values
                    pagination={false}
                    columns={columns}
                  />
                ) : (
                  <Empty description="Sorry, you don`t have any documents." />
                )}
              </div>
            </div>
          </Modal>

          <div
            className="modal fade"
            id="staticBackdropc"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <embed src={contractPdf} type="application/pdf" width="100%" height="450px" />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CandidateList;
